import { useState, useEffect } from "react";
import Image from "components/Elements/Image/Image.tsx";
import Button from "components/Elements/Button/Button.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import { useUser } from "contexts/userContext/userContext.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";

const CustomFormSection = () => {
  const { desktopCondition } = useMediaQueries();
  const { getTextByKey, getDirection } = useContent();
  const [activeStep, setActiveStep] = useState(0);
  const { isPro, isBusiness, isPremium, getUserData } = useUser();
  const jumboFormsCount = getUserData()?.JumboFormsCount;

  const allowCreateForm = () => {
    if (((isPro() || isBusiness()) && !jumboFormsCount) || isPremium()) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    //if device is not mobile, change active step every 5 seconds
    if (window.innerWidth > 600) {
      const interval = setInterval(() => {
        setTimeout(() => {
          setActiveStep((prevActiveStep) =>
            prevActiveStep >= 2 ? 0 : prevActiveStep + 1
          );
        }, 1000);
      }, 10000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [activeStep]);

  const useScrollPosition = () => {
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
      const updatePosition = () => {
        setScrollPosition(window.pageYOffset);
      };
      window.addEventListener("scroll", updatePosition);
      updatePosition();
      return () => window.removeEventListener("scroll", updatePosition);
    }, []);

    return scrollPosition;
  };

  const scrollPosition = useScrollPosition();
  useEffect(() => {
    if (window.innerWidth <= 600) {
      if (getDirection() === "ltr") {
        if (scrollPosition <= 1700) {
          setActiveStep(0);
        } else if (scrollPosition > 1700 && scrollPosition <= 2100) {
          setActiveStep(1);
        } else {
          setActiveStep(2);
        }
      } else {
        if (scrollPosition <= 1700) {
          setActiveStep(0);
        } else if (scrollPosition > 1700 && scrollPosition <= 2000) {
          setActiveStep(1);
        } else {
          setActiveStep(2);
        }
      }
    }
  }, [scrollPosition]);

  return (
    <div className="custom-jumboform-container">
      <div className="top-container part">
        <div className="content-body">
          <div className="content-container">
            <h2>{getTextByKey("custom-jumbo-form-title1")}</h2>
            <p>{getTextByKey("custom-jumbo-form-text1")}</p>
            <LinkToNewTab
            classes="create-form-button"
              page={
                allowCreateForm()
                  ? "create-form"
                  : "user/jumbo-forms/form-management"
              }
            >
              <Button>{getTextByKey("create-form")}</Button>
            </LinkToNewTab>
          </div>
          <div className="image-container">
            <Image
              name={`embed-forms/forms-custom-img-${
                desktopCondition ? "web" : "mob"
              }`}
              ext="png"
              title=""
              alt=""
            />
          </div>
        </div>
      </div>
      <div className="bottom-container part">
        <div className="content-body">
          <div className="image-container">
            <Image
              name={`embed-forms/forms-embed-img${
                desktopCondition ? "" : "-mob"
              }`}
              ext="png"
              title=""
              alt=""
            />
          </div>
          <div className="content-container">
            <h2>{getTextByKey("custom-jumbo-form-title2")}</h2>
            <p>{getTextByKey("custom-jumbo-form-text2")}</p>
            <div className="custom-section">
              <div className="custom-section-title">
                {getTextByKey("custom-jumbo-form-additional-title")}
              </div>
              <p>{getTextByKey("custom-jumbo-form-additional-subtitle")}</p>
              <span>{getTextByKey("custom-jumbo-form-additional-text")}</span>
            </div>
            <LinkToNewTab page="user/jumbo-forms/integration">
              <Button transparent>{getTextByKey("learn-more")}</Button>
            </LinkToNewTab>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomFormSection;
